import React, { useState, useEffect, useContext } from 'react';
import { OverlayTrigger, Tooltip, Form, /*Accordion,*/ Button, Spinner, Row } from 'react-bootstrap';
import Select from 'react-select';
import { TooltipInfoIcon, IcoDownloadFile, IcoAi } from '@icons';
import { getChecklist, editChecklist, downloadChecklist, downloadChecklistHistory } from '@lib/api';
// import { LevelContext } from '@components/contexts/LevelContext';
import OeApiResponseRenderer from '@components/OeApiResponseRenderer';
import DownloadExcelButtons from '@components/form/DownloadExcelButtons';
import { translate } from 'components/translation/translation';
import { OETrans } from 'components/translation/OETrans';
import { DialogConfirmation } from 'components/atomic/molecules/index';
import { UserContext } from 'components/contexts/UserProvider';
import Banner from '@components/atomic/atoms/Banner/Banner';
import { useHasPermission } from '@lib/hooks/useHasPermission';
import { useCanEditChecklist } from '@lib/hooks/useCanEditChecklist';

const QuestionComponent = ({
	question,
	answerByQuestion,
	handleAnswersChange,
	handleChecked,
	handleValue,
	indexQ,
	checklistId,
	disabled,
	devMode,
	canViewAIDisclaimer,
}) => {
	const optionsNotes = question.notes.map((note) => ({
		value: note.code,
		label: note.name,
	}));

	const renderTooltip = (props) => (
		<Tooltip id="button-tooltip" {...props}>
			{question.description}
		</Tooltip>
	);

	return (
		<>
			<div id={`questionID-${question.code}`} name={question.code} questionid={question.code}>
				{
					Number(indexQ) !== 0 && (
						<div
							style={{
								marginBottom: '1.5rem',
							}}
						/>
					)
					// <hr className="hr-question" />
				}
				<div
					// className="row justify-content-start"
					// style={{
					// 	flexWrap: 'nowrap',
					// }}
					className="row"
					style={{
						display: 'grid',
						gridTemplateColumns: '40px 1fr',
						gap: '1rem',
					}}
				>
					<div
						style={{
							// width: '40px',
							borderRight: '4px solid #DEE4F1',
							// marginRight: '1rem',
							fontSize: '24px',
							fontWeight: 700,
							textAlign: 'right',
							paddingLeft: 0,
						}}
					>
						{indexQ + 1}
					</div>
					<div
						style={{
							width: '100%',
						}}
						//  className={`col-6 ${devMode ? '' : 'ps-4'}`}
					>
						<div className="row">
							<span
								style={{
									fontWeight: 700,
									paddingLeft: 0,
									marginBottom: '0.5rem',
								}}
							>
								{question?.questionsFormatted?.length > 0 ? question.questionsFormatted : question.questions}
							</span>
							{devMode ? (
								<span
									className="question-code"
									style={{
										marginBottom: '0.5rem',
									}}
								>
									{question.code}
								</span>
							) : null}
							{question?.objective?.length > 0 ? (
								<span className="text-start ps-0" style={{ fontSize: '18px' }}>
									{question?.objective}
								</span>
							) : (
								''
							)}

							{question.description ? (
								<OverlayTrigger placement="top" delay={{ show: 200, hide: 400 }} overlay={renderTooltip}>
									<TooltipInfoIcon className="tooltip-ico" style={{ width: '1rem' }} />
								</OverlayTrigger>
							) : null}
						</div>

						{/* <div className="row mt-4">
							<Form.Control
								as="textarea"
								rows={2}
								disabled={disabled}
								name={`${question.code}`}
								placeholder="Note"
								defaultValue={handleValue(checklistId, question.code, 'note')}
								onChange={(e) => handleAnswersChange(e, 'note')}
							/>
						</div>

						{optionsNotes.length > 0 ? (
							<div className="row mt-4">
								<span className="fw-bold text-start ps-0" style={{ fontSize: '.7rem' }}>
									Dettaglio risposta
								</span>
								<Select
									components={{
										IndicatorSeparator: () => null,
									}}
									className="react-select-container value-nowrap px-0"
									classNamePrefix="react-select"
									name="noteCode"
									placeholder={translate('common.placeholder.select', 'Seleziona...')}
									value={optionsNotes.filter((opt) => opt.value === answerByQuestion.noteCode)}
									options={optionsNotes}
									onChange={(e) => handleAnswersChange(e, 'noteCode', question.code)}
									isDisabled={disabled}
									isClearable
								/>
							</div>
						) : null} */}

						{/* <div className='row mt-3'>
                     <Form.Control
                        as='textarea'
                        rows={1}
                        disabled={disabled}
                        name={`${question.code}`}
                        placeholder='Note documenti'
                        defaultValue={handleValue(checklistId, question.code, 'documents')}
                        onChange={(e) => handleAnswersChange(e, 'documents')}
                     />
                  </div> */}

						<div
							className="row"
							// className="row text-center"
							style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: '1rem',
								marginTop: '1.5rem',
								width: '100%',
							}}
						>
							{
								// ['yes', 'rec', 'no', 'na', 'nd']
								[
									{
										value: 'yes',
										label: 'SÌ',
									},
									{
										value: 'no',
										label: 'NO',
									},
									{
										value: 'rec',
										label: 'DA VALIDARE',
									},
									{
										value: 'na',
										label: 'NON APPLICABILE',
									},
									{
										value: 'nd',
										label: 'NON DISPONIBILE',
									},
								].map((field) => (
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											padding: 0,
											width: 'fit-content',
										}}
										// className="col pe-0 d-flex flex-column align-items-center"
										key={`${question.code}-${field.value}`}
									>
										<Form.Label
											htmlFor={`${question.code}-${field.value}`}
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: '0.5rem',
												padding: '0.5rem 1rem',
												borderWidth: '1px',
												borderStyle: 'solid',
												borderRadius: '0.5rem',

												borderColor: disabled ? '#E3E7EB' : 'initial',
												color: disabled ? '#ABB7C3' : 'initial',

												backgroundColor: disabled ? '#E3E7EB' : 'initial',
												cursor: disabled ? 'default' : 'pointer',
											}}
										>
											<Form.Check
												inline
												className="custom-checklist-radio"
												style={{ margin: 0, display: 'flex', alignItems: 'center' }}
												type="radio"
												id={`${question.code}-${field.value}`}
												disabled={disabled}
												name={`${question.code}`}
												onChange={(e) => handleAnswersChange(e, field.value)}
												defaultChecked={handleChecked(question.code, field.value)}
											/>
											{field.label}
											{canViewAIDisclaimer && answerByQuestion.ai && handleChecked(question.code, field.value, true) ? (
												<OverlayTrigger
													placement="top"
													delay={{ show: 200, hide: 400 }}
													overlay={
														<Tooltip className="">
															<OETrans code="checklist.tooltip.ai" fallback={"Risposta generata dall'intelligenza artificiale"} />
														</Tooltip>
													}
												>
													<IcoAi
														style={{
															fill: '#1C2743',
														}}
													/>
												</OverlayTrigger>
											) : (
												''
											)}
										</Form.Label>
									</div>
								))
							}
						</div>

						<div className="row mt-4">
							<Form.Label
								style={{
									padding: 0,
									fontSize: '16px',
									fontWeight: '500',
								}}
							>
								Nota da integrare nella risposta
							</Form.Label>
							<Form.Control
								as="textarea"
								rows={2}
								disabled={disabled}
								name={`${question.code}`}
								placeholder="Scrivi il contenuto della nota..."
								defaultValue={handleValue(checklistId, question.code, 'note')}
								onChange={(e) => handleAnswersChange(e, 'note')}
							/>
						</div>

						{optionsNotes.length > 0 ? (
							<div className="row mt-4">
								<span className="fw-bold text-start ps-0" style={{ fontSize: '.7rem' }}>
									Dettaglio risposta
								</span>
								<Select
									components={{
										IndicatorSeparator: () => null,
									}}
									className="react-select-container value-nowrap px-0"
									classNamePrefix="react-select"
									name="noteCode"
									placeholder={translate('common.placeholder.select', 'Seleziona...')}
									value={optionsNotes.filter((opt) => opt.value === answerByQuestion.noteCode)}
									options={optionsNotes}
									onChange={(e) => handleAnswersChange(e, 'noteCode', question.code)}
									isDisabled={disabled}
									isClearable
								/>
							</div>
						) : null}
					</div>
				</div>
			</div>
		</>
	);
};

const CheckList = ({ entityType, entityId, disabled = false, hasInternalDownload = true, hasStandardChecklist, hasEnabledAi = false }) => {
	// const { devMode } = useContext(LevelContext);
	const devMode = localStorage.getItem('devMode') === 'true' ? true : false;
	const canViewAIDisclaimer = useHasPermission(['view-ai-disclaimer'], 'all');
	const canEditChecklist = useCanEditChecklist(entityType);
	const { userAccess } = useContext(UserContext);
	const [checklist, setChecklist] = useState({});
	const [categories, setCategories] = useState([]);
	const [answers, setAnswers] = useState([]);
	const [note, setNote] = useState('');
	const [originNote, setOriginNote] = useState('');
	const [sbShow, setSbShow] = useState(<></>);
	const [initialAnswers, setInitialAnswers] = useState([]);
	const [isPending, setIsPending] = useState(false);
	const [isDownloadingButton1, setIsDownloadingButton1] = useState(false);
	const [isDownloadingButton2, setIsDownloadingButton2] = useState(false);
	const [isDownloadingButton3, setIsDownloadingButton3] = useState(false);
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);

	const handleStatusBar = (dataToHandle) => {
		setSbShow(<OeApiResponseRenderer dataToHandle={dataToHandle} />);
	};

	useEffect(() => {
		getChecklist(entityType, entityId).then((retrievedChecklist) => {
			if (retrievedChecklist.data) {
				setChecklist(retrievedChecklist.data);
				setAnswers(
					retrievedChecklist.data.answers.map((answer) => ({
						...answer,
						order: retrievedChecklist.data.questions.find((question) => question.code === answer.questionCode)?.sectionNumber,
					})),
				);
				setOriginNote(retrievedChecklist.data.note);
				setNote(retrievedChecklist.data.note);

				setInitialAnswers(JSON.parse(JSON.stringify(retrievedChecklist.data.answers)));

				setCategories(
					retrievedChecklist.data.questions
						.filter((quest, index, array) => array.findIndex((el) => el.sectionNumber === quest.sectionNumber) === index)
						.map((filteredElement) => ({
							code: filteredElement.code,
							order: filteredElement.sectionNumber,
							text: filteredElement.sectionName,
						})),
				);
			}
		});
	}, [entityId, entityType]);

	useEffect(() => {
		handleChecked();
		handleValue();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [answers]);

	useEffect(() => {
		setChecklist({});
		setAnswers([]);
		setInitialAnswers([]);
		setCategories([]);
	}, [entityId]);

	const handleAnswersChange = async (e, fieldName, questionCodeSelect) => {
		let tempState = [...answers];

		if (e && e.target) {
			const questionCode = e.target.name;

			switch (e.target.type) {
				case 'radio':
					answers.forEach((answ, index) => {
						if (answ.questionCode === questionCode) {
							tempState[index]['yes'] = 0;
							tempState[index]['no'] = 0;
							tempState[index]['na'] = 0;
							tempState[index]['nd'] = 0;
							tempState[index]['rec'] = 0;
							tempState[index][fieldName] = 1;
						}
					});

					break;
				case 'textarea':
					answers.forEach((answ, index) => {
						if (answ.questionCode === questionCode) {
							tempState[index][fieldName] = e.target.value;
						}
					});
					break;
				default:
					break;
			}
		} else if (fieldName === 'noteCode') {
			let value = e ? e.value : null;

			/*let tempElement = {
            ...tempState[elIndex],
            [fieldNameSubject]: value,
            frameworkContractId: detail.id,
         };

         tempState[elIndex] = tempElement; */

			answers.forEach((answ, index) => {
				if (answ.questionCode === questionCodeSelect) {
					tempState[index][fieldName] = value;
				}
			});
		}

		setAnswers(tempState);
	};

	const handleChecked = (questionCode, fieldName, checkAi) => {
		let boolean = false;
		let arrayAnswers = checkAi ? initialAnswers : answers;

		arrayAnswers.forEach((answ) => {
			if (answ.questionCode === questionCode) {
				if (answ[fieldName]) {
					boolean = true;
				} else {
					boolean = false;
				}
			}
		});

		return boolean;
	};

	const handleValue = (checklistId, questionCode, fieldName) => {
		let value;

		value = answers
			.filter((answ) => answ.checklistId === checklistId && answ.questionCode === questionCode)
			.map((filteredAnsw) => filteredAnsw[fieldName]);

		return value ?? '';
	};

	const handleSave = async (e) => {
		if (e) e.preventDefault();

		setSbShow(<></>);

		const hasAI = answers.some((answ) => answ.ai === true);

		//Take from answers only the modified ones
		let modifiedAnswers = answers.filter((answ) => {
			const initialAnswer = initialAnswers.find((el) => el.id === answ.id);
			return JSON.stringify(answ) !== JSON.stringify(initialAnswer);
		});

		if (hasAI && !showConfirmationModal && modifiedAnswers.length > 0 && modifiedAnswers.some((answ) => answ.ai)) {
			setShowConfirmationModal(true);
			return;
		}

		if (modifiedAnswers.some((answ) => answ.ai)) {
			modifiedAnswers.forEach((modAnsw) => {
				//Trova l'oggetto con lo stesso id
				const initialObj = initialAnswers.find((obj) => obj.id === modAnsw.id);

				//Se l'oggetto è stato trovato in initialAnswers e c'è una differenza nelle proprietà specifiche, aggiorna 'ai' a false
				if (
					initialObj &&
					(initialObj.yes !== modAnsw.yes ||
						initialObj.no !== modAnsw.no ||
						initialObj.na !== modAnsw.na ||
						initialObj.nd !== modAnsw.nd ||
						initialObj.rec !== modAnsw.rec)
				) {
					modAnsw.ai = false;
				}
			});
		}

		modifiedAnswers = modifiedAnswers.map(({ createdAt, createdBy, updatedAt, updatedBy, ...restItem }) => {
			return restItem;
		});

		if (modifiedAnswers.length === 0 && note === originNote) {
			handleStatusBar({ success: true, message: 'Nessuna modifica da salvare' });
		} else {
			let payload = {
				...(note !== originNote && { note: note }),
				...(modifiedAnswers.length > 0 && { answers: modifiedAnswers }),
			};

			const editResult = await editChecklist(checklist.id, payload);

			handleStatusBar(editResult);

			if (editResult.success) {
				getChecklist(entityType, entityId).then((retrievedChecklist) => {
					if (retrievedChecklist.data) {
						setChecklist(retrievedChecklist.data);
						setAnswers(
							retrievedChecklist.data.answers.map((answer) => ({
								...answer,
								order: retrievedChecklist.data.questions.find((question) => question.code === answer.questionCode)?.sectionNumber,
							})),
						);
						setOriginNote(retrievedChecklist.data.note);
						setNote(retrievedChecklist.data.note);

						setInitialAnswers(JSON.parse(JSON.stringify(retrievedChecklist.data.answers)));
					}
				});
			}
		}
	};

	const handleDownloadCL = async () => {
		setSbShow(<></>);
		setIsPending(true);

		const result = await downloadChecklist([entityType, entityId]);

		if (result) {
			setIsPending(false);
		}
	};

	const renderTooltip = (props, classWidth) => {
		let message = '';

		if (props.popper.state) {
			message = props.popper.state.options.testObj;
		}

		return (
			<Tooltip id="button-tooltip" {...props} {...(classWidth ? { className: classWidth } : null)}>
				{message}
			</Tooltip>
		);
	};

	return (
		<>
			<div>
				<DialogConfirmation
					typeConfirm="primary"
					show={showConfirmationModal}
					title="Modifica"
					content={
						canViewAIDisclaimer && hasEnabledAi ? (
							<>
								Salvando queste attività procedi a validare il supporto fornito dal controllo automatizzato basato su Intelligenza
								Artificiale.
								<br />
								<br />
								L'attività di verifica automatica costituisce un supporto decisionale al controllo umano, ma non lo sostituisce. I risultati
								devono essere oggetto di revisione e validazione da parte dell'utente o del team competente.
							</>
						) : (
							'Confermi di modificare/validare le risposte?'
						)
					}
					confirmLabel="Modifica"
					cancelLabel="Annulla"
					onHide={() => setShowConfirmationModal(false)}
					onCancel={() => setShowConfirmationModal(false)}
					onConfirm={() => {
						handleSave();
						setShowConfirmationModal(false);
					}}
				/>
				<Form onSubmit={(e) => handleSave(e)} id={'checklist-' + entityType} className="p-0">
					<div /* className='checklist-scroll' */>
						{/* <div className="row checklist-header"> */}
						{hasInternalDownload ? (
							<div className="row">
								<div className={devMode ? 'col-7' : 'col-6'}>
									{entityType === 'tenders' || entityType === 'frameworkContracts' ? (
										<DownloadExcelButtons
											textHeader={translate('common.downloadexcel', 'Scarica excel')}
											dropdownItems={[
												{
													text: translate('common.workchecklist', 'Checklist di lavoro'),
													isDownloadingButton: isDownloadingButton1,
													setIsDownloadingButton: setIsDownloadingButton1,
													apiDownload: downloadChecklist,
													apiProps: [entityType, entityId],
												},
												...(userAccess.isAboveGuest &&
												// se hasStandardChecklist è undefined o true, le checklist standard sono scaricabili
												(hasStandardChecklist === undefined || hasStandardChecklist)
													? [
															{
																text: translate('common.downloadverticalcl', 'Checklist standard'),
																isDownloadingButton: isDownloadingButton2,
																setIsDownloadingButton: setIsDownloadingButton2,
																apiDownload: downloadChecklist,
																apiProps: [entityType, entityId, true],
															},
														]
													: []),
												...(userAccess.isExternalAdmin
													? [
															{
																text: translate('common.downloadhistory', 'Storico risposte'),
																isDownloadingButton: isDownloadingButton3,
																setIsDownloadingButton: setIsDownloadingButton3,
																apiDownload: downloadChecklistHistory,
																apiProps: checklist?.id,
															},
														]
													: []),
											]}
											customClassStyle="ms-3"
										/>
									) : (
										<>
											<OverlayTrigger
												placement="top"
												overlay={
													<Tooltip>
														<OETrans code="common.downloadcl" fallback={'Scarica checklist'} />
													</Tooltip>
												}
											>
												<Button variant="link" className="ms-3" onClick={() => handleDownloadCL()}>
													<IcoDownloadFile className="second-color ico-small massive-upload align-bottom" />
												</Button>
											</OverlayTrigger>
											{userAccess.isExternalAdmin && (
												<DownloadExcelButtons
													textHeader={translate('common.downloadexcel', 'Scarica excel')}
													dropdownItems={[
														{
															text: translate('common.downloadhistory', 'Storico risposte'),
															isDownloadingButton: isDownloadingButton3,
															setIsDownloadingButton: setIsDownloadingButton3,
															apiDownload: downloadChecklistHistory,
															apiProps: checklist?.id,
														},
													]}
													customClassStyle="ms-3 d-inline-block"
												/>
											)}
										</>
									)}
									{isPending && <Spinner as="span" className="ms-2" animation="border" size="sm" role="status" aria-hidden="true" />}
								</div>

								{/* {answers.filter((answ) => {
									return answ.checklistId === checklist.id && answ.order === checklist.sectionNumber && Number(answ.no) === 1;
								}).length > 0 ? (
									<Row
										style={{
											marginTop: '1.5rem',
										}}
									>
										<div
											style={{
												padding: '1rem',
												borderRadius: '8px',
												backgroundColor: '#FBEFF1',
												color: '#CC334C',
												marginBottom: '1.5rem',
												maxWidth: 'fit-content',
												fontWeight: 500,
											}}
										>
											Quantità di risposte “NO” inserite:{' '}
											<span
												style={{
													fontWeight: 700,
												}}
											>
												{
													answers.filter(
														(answ) => answ.checklistId === checklist.id && answ.order === checklist.sectionNumber && Number(answ.no) === 1,
													).length
												}
											</span>
										</div>
									</Row>
								) : null} */}
								{/* <div className="col px-3">
							<div className="row text-center flex-nowrap">
								<div className="col fw-bold p-0 cl-custom-width">SÌ</div>
								<div className="col fw-bold p-0 cl-custom-width">REC.</div>
								<div className="col fw-bold p-0 cl-custom-width">
									NO
									<br />
									<span className="mt-3 summary-check">
										{checklist.answers?.reduce((prev, curr) => prev + curr.no, 0) > 0
											? checklist.answers?.reduce((prev, curr) => prev + curr.no, 0)
											: null}{' '}
										{
											// number of NO
										}
									</span>
								</div>
								<div className="col fw-bold p-0 cl-custom-width">N.A.</div>
								<div className="col fw-bold p-0 cl-custom-width">N.D.</div>
							</div>
						</div> */}
							</div>
						) : null}

						{checklist.numberOfQuestions > 0 ? (
							<>
								{categories
									?.sort((catA, catB) => catA.order - catB.order)
									?.map((category, indexCat) => {
										return (
											<div className="row w-100 p-4" key={'cat-' + indexCat}>
												<div className="col-lg-12">
													<div>
														{checklist.questions.filter((question) => question.sectionNumber === category.order).length > 0 ? (
															<div>
																{/* <Accordion defaultActiveKey={indexCat + 1} style={{ marginBottom: '1.5rem' }} flush alwaysOpen> */}
																{/* <Accordion.Item eventKey={indexCat + 1}> */}
																{/* <Accordion.Header as="h5" className="accordion-title"> */}
																<div className="row w-100 align-items-center mb-4">
																	<div className="col-8 pe-3 ps-0">
																		<div className="d-flex title-simple-box margin-title-box align-items-center" style={{ height: '100%' }}>
																			<h4
																				style={{
																					fontWeight: 700,
																				}}
																			>
																				{category.text}
																			</h4>
																			{category.description ? (
																				<OverlayTrigger
																					placement="right"
																					delay={{ show: 200, hide: 400 }}
																					overlay={renderTooltip}
																					popperConfig={{ testObj: category.description }}
																				>
																					<TooltipInfoIcon className="tooltip-ico" style={{ width: '1rem' }} />
																				</OverlayTrigger>
																			) : null}
																		</div>
																	</div>
																</div>

																{answers.filter((answ) => {
																	return answ.checklistId === checklist.id && answ.order === category.order && Number(answ.no) === 1;
																}).length > 0 ? (
																	<Row>
																		<div
																			style={{
																				padding: '1rem',
																				borderRadius: '8px',
																				backgroundColor: '#FBEFF1',
																				color: '#CC334C',
																				marginBottom: '1.5rem',
																				maxWidth: 'fit-content',
																				fontWeight: 500,
																			}}
																		>
																			Quantità di risposte “NO” inserite:{' '}
																			<span
																				style={{
																					fontWeight: 700,
																				}}
																			>
																				{
																					answers.filter(
																						(answ) =>
																							answ.checklistId === checklist.id && answ.order === category.order && Number(answ.no) === 1,
																					).length
																				}
																			</span>
																		</div>
																	</Row>
																) : null}
																{/* <Row>
																<hr />
															</Row> */}

																{/* </Accordion.Header> */}
																{/* <Accordion.Body className=""> */}
																{checklist.questions
																	?.filter((question) => question.sectionNumber === category.order)
																	?.sort((questA, questB) => Number(questA.number) - Number(questB.number))
																	?.map((question, indexQ) => {
																		return (
																			<QuestionComponent
																				key={'quest-' + indexQ}
																				question={question}
																				answerByQuestion={answers.find((answ) => answ.questionCode === question.code)}
																				handleChecked={handleChecked}
																				handleAnswersChange={handleAnswersChange}
																				handleValue={handleValue}
																				indexQ={indexQ}
																				checklistId={checklist.id}
																				disabled={disabled || !canEditChecklist}
																				devMode={devMode}
																				canViewAIDisclaimer={canViewAIDisclaimer}
																			/>
																		);
																	})}
																{/* </Accordion.Body> */}
																{/* </Accordion.Item> */}
																{/* </Accordion> */}
															</div>
														) : null}
													</div>
												</div>
											</div>
										);
									})}

								{canViewAIDisclaimer && hasEnabledAi ? (
									<Banner
										variant="info"
										hasIcon={false}
										message={
											<p className="mb-0">
												Il controllo automatizzato basato su Intelligenza Artificiale viene configurato sulla base delle specifiche
												normative e della documentazione disponibile; tuttavia, eventuali anomalie nei dati o nei documenti caricati possono
												influire sull'esito dell'analisi.&nbsp;
												<span className="f-600">
													L'attività di verifica automatica costituisce un supporto decisionale al controllo umano, ma non lo sostituisce. I
													risultati devono essere oggetto di revisione e validazione da parte dell'utente o del team competente.
												</span>
											</p>
										}
										className="mt-4 ms-0 me-4 mb-0"
									/>
								) : null}

								<div className="row w-100 justify-content-start mt-3 pb-3 px-3">
									<hr className="hr-question" style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto' }} />
									<div
										style={{
											backgroundColor: '#EDF0F7',
											padding: '1rem',
											borderBottomLeftRadius: '12px',
											borderBottomRightRadius: '12px',
										}}
									>
										<div className="row">
											<Form.Group className="pe-2">
												<h3
													style={{
														fontSize: '24px',
														fontWeight: 700,
													}}
												>
													Vuoi integrare ulteriori note alla checklist?
												</h3>

												<Form.Label className="mb-3">
													{/* <OETrans code="checklist.note" fallback={'Note'} /> */}
													Nota da integrare alla checklist
												</Form.Label>
												<Form.Control
													as="textarea"
													rows={3}
													name="note"
													value={note ?? ''}
													onChange={(e) => setNote(e.target.value)}
													placeholder="Scrivi il contenuto della nota..."
												/>
											</Form.Group>
										</div>
									</div>
								</div>
							</>
						) : null}
					</div>
				</Form>
			</div>
			{sbShow}
		</>
	);
};
export default CheckList;
